var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 6a1.333 1.333 0 1 0-2.667 0v4.695l-1.04-1.08a1.334 1.334 0 0 0-1.92 1.85l3.333 3.46a1.33 1.33 0 0 0 1.92 0l3.334-3.46a1.333 1.333 0 1 0-1.92-1.85l-1.04 1.08z",
    fill: "#FF5956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0c5.523 0 10 4.477 10 10 0 5.524-4.476 10-10 10-5.523 0-10-4.476-10-10C0 4.477 4.477 0 10 0m7.334 10a7.334 7.334 0 1 0-14.668 0 7.334 7.334 0 0 0 14.668 0",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.68aa69d887af9c8b7f9208a13e7090de.svg";
export { ForwardRef as ReactComponent };